import React from 'react';
import DocCiteTrendsMini from '@/features/researcher/components/charts/DocCiteTrendsMini';

/**
 * ResearcherSidebar
 * - Extracted right-side panel for Researcher detail page.
 * - Presentational component that consumes a `record` object only.
 * - Values are read from `record.meta` and `record.research_all_achievement`.
 */
export default function ResearcherSidebar({ record } = {}) {

  const meta = record?.meta || {};

  // Read values only from record fields (number 포맷: 천 단위 콤마)
  const num = (v) => (typeof v === 'number' && !Number.isNaN(v) ? v : Number(v) || 0);
  const fmt = (v) => num(v).toLocaleString();
  const computedHIndex = {
    wos: meta.hindex_wos ?? 0,
    scopus: meta.hindex_scopus ?? 0,
    kci: meta.hindex_kci ?? 0,
  };
  const hIndexWosFmt = fmt(computedHIndex.wos);
  const hIndexScopusFmt = fmt(computedHIndex.scopus);
  const hIndexKciFmt = fmt(computedHIndex.kci);

  const computedLastUpdate = meta.hindex_updated || '-';

  // Use `record.research_all_achievement` as the data source (number 포맷: 천 단위 콤마)
  const raa = record?.research_all_achievement || {};
  const computedScholarlyOutput = raa.resource_count ?? 0;
  const computedCitationCount = raa.cited_count ?? 0;
  const scholarlyOutputFmt = fmt(computedScholarlyOutput);
  const citationCountFmt = fmt(computedCitationCount);

  // Publications by year data for chart
  const pubYearData = record?.publications_by_year?.data || [];

  return (
    <div className="right-box hidden relative mt-[105px] w-[calc((100%-40px)*0.3)] shrink-0 lg:block">
      <div className="absolute bottom-[calc(100%+16px)] w-full flex justify-end gap-[10px] text-[14px] text-[#8D9AAF]">
        <span className="font-bold">Last Update</span>
        <span>{computedLastUpdate}</span>
      </div>

      <div className="w-full p-10 bg-white rounded-xl">
        <div className="mb-10">
          <h2 className="flex items-center gap-[6px] mb-[14px]">
            <span className="text-[18px] font-bold leading-[100%]">H-Index</span>
          </h2>

          <div className="flex flex-wrap gap-2">
            <div className="px-4 py-[10px] text-[13px] font-medium text-[#532EB3] leading-[100%] border border-[#E4E8F1] rounded-[12px]">
              Web of Science{' '}
              <span className="ml-1 py-[2px] px-[6px] bg-[#532EB3] text-white font-bold rounded-full">{hIndexWosFmt}</span>
            </div>

            <div className="px-4 py-[10px] text-[13px] font-medium text-[#F3652D] leading-[100%] border border-[#E4E8F1] rounded-[12px]">
              Scopus{' '}
              <span className="ml-1 py-[2px] px-[6px] bg-[#F3652D] text-white font-bold rounded-full">{hIndexScopusFmt}</span>
            </div>

            <div className="px-4 py-[10px] text-[13px] font-medium text-[#2D7ECF] leading-[100%] border border-[#E4E8F1] rounded-[12px]">
              KCI{' '}
              <span className="ml-1 py-[2px] px-[6px] bg-[#2D7ECF] text-white font-bold rounded-full">{hIndexKciFmt}</span>
            </div>
          </div>
        </div>

        <div>
          <h2 className="flex items-center gap-[6px] mb-[14px]">
            <span className="text-[18px] font-bold leading-[100%]">Document & Citation trends</span>
          </h2>

          <div className="flex flex-col flex-wrap gap-3 2xl:flex-row">
            <div className="w-full px-6 py-5 font-bold leading-[100%] border border-[#E4E8F1] rounded-[12px] 2xl:w-[calc((100%-12px)/2)]">
              <h3 className="mb-[6px] text-[14px] text-[#8D9AAF]">Schoarly Output</h3>
              <span className="text-[18px] text-[#376BDB]">{scholarlyOutputFmt}</span>
            </div>

            <div className="w-full px-6 py-5 font-bold leading-[100%] border border-[#E4E8F1] rounded-[12px] 2xl:w-[calc((100%-12px)/2)]">
              <h3 className="mb-[6px] text-[14px] text-[#8D9AAF]">Citation Count</h3>
              <span className="text-[18px] text-[#376BDB]">{citationCountFmt}</span>
            </div>

            <div className="w-full px-5 py-8 border border-[#E4E8F1] rounded-[12px]">
              <DocCiteTrendsMini data={pubYearData} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
